// FILE: src/components/AuthenticatedImage.js
// BRAND NEW FILE — does not exist in your project yet.
//
// WHY THIS IS NEEDED:
// The backend selfie endpoint GET /api/attendance/selfie/** requires a JWT token.
// A plain <img src="http://..."> tag cannot send the Authorization header, so
// every selfie would return 401/403 and show a broken image.
// This component fetches the image through axios (which has the token interceptor),
// converts the blob to an object URL, and renders it as a normal <img>.

import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import api from '../api/axios';

const AuthenticatedImage = ({ src, alt = '', size = 56, sx = {}, onClick }) => {
    const [objectUrl, setObjectUrl] = useState(null);
    const [status, setStatus] = useState('loading'); // loading | ready | error

    useEffect(() => {
        let currentUrl = null;
        let cancelled = false;

        if (!src) {
            setStatus('error');
            return;
        }

        setStatus('loading');

        api.get(src, { responseType: 'blob' })
            .then((res) => {
    if (cancelled) return;

    if (!res.data.type || !res.data.type.startsWith('image/')) {
        throw new Error('Response is not an image');
    }

    currentUrl = URL.createObjectURL(res.data);
    setObjectUrl(currentUrl);
    setStatus('ready');
})
            .catch(() => {
                if (!cancelled) setStatus('error');
            });

        return () => {
            cancelled = true;
            if (currentUrl) URL.revokeObjectURL(currentUrl);
        };
    }, [src]);

    const baseSx = {
        width: size,
        height: size,
        borderRadius: 1,
        ...sx
    };

    if (status === 'loading') {
        return (
            <Box sx={{ ...baseSx, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f1f5f9' }}>
                <CircularProgress size={18} />
            </Box>
        );
    }

    if (status === 'error') {
        return (
            <Box sx={{ ...baseSx, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f1f5f9' }}>
                <Typography variant="caption" color="text.secondary">N/A</Typography>
            </Box>
        );
    }

    return (
        <Box
            component="img"
            src={objectUrl}
            alt={alt}
            onClick={onClick}
            sx={{ ...baseSx, objectFit: 'cover', cursor: onClick ? 'pointer' : 'default' }}
        />
    );
};

export default AuthenticatedImage;
